var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "refresh_1_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    fill: "#FFFFFF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.487,79.02c1.165,1.166,1.494,2.925,0.833,4.436c-0.661,1.511-2.183,2.458-3.829,2.391l-12.748-0.541 c-2.135-0.09-4.11-1.005-5.557-2.581c-1.447-1.572-2.19-3.615-2.096-5.748l10.466,0.444l0.011-0.026 c-5.62-5.626-9.491-12.682-11.194-20.41C4.281,42.958,8.759,28.491,19.352,18.287C29.947,8.081,44.582,4.147,58.493,7.763 l-2.012,7.743c-11.202-2.912-23.005,0.283-31.58,8.542c-8.572,8.258-12.205,19.927-9.717,31.214 c1.375,6.238,4.503,11.938,9.047,16.485l-0.006,0.006L31.487,79.02z M88.583,39.015c-1.703-7.727-5.574-14.784-11.194-20.411 c0.011-0.025,10.477,0.419,10.477,0.419c0.093-2.133-0.649-4.176-2.096-5.748c-1.447-1.577-3.422-2.492-5.557-2.581l-12.749-0.541 c-1.646-0.067-3.168,0.88-3.829,2.391c-0.661,1.511-0.332,3.27,0.833,4.436l7.262,7.266c4.537,4.553,7.666,10.253,9.041,16.491 c2.499,11.339-1.17,23.041-9.814,31.303c-8.649,8.264-20.515,11.396-31.741,8.386l-2.074,7.727 c3.507,0.941,7.061,1.402,10.587,1.402c10.502,0,20.756-4.087,28.755-11.731C87.165,67.614,91.688,53.106,88.583,39.015z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.73b84efec400454bd4aec93b2435860f.svg";
export { ForwardRef as ReactComponent };